import React, { Component } from 'react';
import { connect } from "react-redux";
import $ from 'jquery';
import '../css/validations.css'
import moment from 'moment';

class LocationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    closeModal = () => {
        $("#locationModal").modal("hide");
    }

    render() {
        const { model } = this.props;
        return (
            <div
                className="modal fade bd-example-modal-lg modal-open scroll"
                id="locationModal"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title"> Datos Maestros de Ubicación </h4>
                            <button type="button" className="close" aria-label="Close" onClick={this.closeModal}>
                                <span className="text-white" aria-hidden="true"> &times; </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table response mb-0">
                                                <div className="row pr-0 mb-1">

                                                    {/*PRIMER COLUMNA UBICACIONES*/}
                                                    <div className="col-12 col-md-6">
                                                        {/*CÓDIGO DE ALMACÉN*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="lblWhsCode">Almacén</span>
                                                            </div>
                                                            <input
                                                                id="txtWhsCode"
                                                                title="Código de almacén"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={model.WhsCode} />
                                                        </div>

                                                        {/*CARA*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="lblSL1Code">Cara</span>
                                                            </div>
                                                            <input
                                                                id="txtSL1Code"
                                                                title="Cara"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={model.SL1Code} />
                                                        </div>

                                                        {/*CÓDIGO DE UBICACIÓN*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="lblBinCode">Ubicación</span>
                                                            </div>
                                                            <input
                                                                id="txtBinCode"
                                                                title="Código de ubicación"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={model.BinCode} />
                                                        </div>
                                                    </div>

                                                    {/*SEGUNDA COLUMNA UBICACIONES*/}
                                                    <div className="col-12 col-md-6">
                                                        {/*PROFUNDIDAD*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="lblSL2Code">Profundidad</span>
                                                            </div>
                                                            <input
                                                                id="txtSL2Code"
                                                                title="Profundidad"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={model.SL2Code} />
                                                        </div>

                                                        {/*ALTURA*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="lblSL3Code">Altura</span>
                                                            </div>
                                                            <input
                                                                id="txtSL3Code"
                                                                title="Altura"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={model.SL3Code} />
                                                        </div>

                                                        {/*DIVISIÓN*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="lblSL4Code">División</span>
                                                            </div>
                                                            <input
                                                                id="txtSL4Code"
                                                                title="División"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={model.SL4Code} />
                                                        </div>
                                                    </div>

                                                </div>
                                                <hr />
                                                <div className="row mt-3 pl-3">
                                                    <h5>Propiedades de la ubicación</h5>
                                                </div>
                                                <div className="row mt-2 pr-0">
                                                    {/*PRIMER COLUMNA PROPIEDADES*/}
                                                    <div className="col-12 col-md-6">
                                                        {/*INACTIVO*/}
                                                        <div className="input-group mb-3 font-weight-bold">
                                                            <label>
                                                                <input
                                                                    id="txtDisabled"
                                                                    title="Inactivo"
                                                                    className="mr-3"
                                                                    type="checkbox"
                                                                    disabled
                                                                    value={model.Disabled === "Y"} />
                                                                Inactivo
                                                            </label>
                                                        </div>
                                                        {/*UBICACIÓN RECEPTORA*/}
                                                        <div className="input-group mb-3 font-weight-bold">
                                                            <label>
                                                                <input
                                                                    id="txtReceiveBin"
                                                                    title="Ubicación receptora"
                                                                    className="mr-3"
                                                                    type="checkbox"
                                                                    disabled
                                                                    value={model.ReceiveBin === "Y"} />
                                                                Ubicación receptora
                                                            </label>
                                                        </div>
                                                    </div>

                                                    {/*SEGUNDA COLUMNA UBICACIONES*/}
                                                    <div className="col-12 col-md-6">
                                                        {/*RESTRINGIR UBICACIÓN VACÍA*/}
                                                        <div className="input-group mb-3 font-weight-bold">
                                                            <label>
                                                                <input
                                                                    id="txtNoAutoAllc"
                                                                    title="Restringir entradas a ubicación vacía"
                                                                    className="mr-3"
                                                                    type="checkbox"
                                                                    disabled
                                                                    value={model.NoAutoAllc === "Y"} />
                                                                Restringir entradas a ubicación vacía
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-1 pr-0">
                                                    {/*PRIMER COLUMNA PROPIEDADES*/}
                                                    <div className="col-12 col-md-6">
                                                        {/*CÓDIGO DE CLASIFICACIÓN ALTERNATIVO*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="lblAltSortCod">Cód. alternativo</span>
                                                            </div>
                                                            <input
                                                                id="txtAltSortCod"
                                                                title="Código de clasificación alternativo"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={model.AltSortCod} />
                                                        </div>

                                                        {/*DESCRIPCIÓN*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="lblDescr">Descripción</span>
                                                            </div>
                                                            <input
                                                                id="txtDescr"
                                                                title="Descripción"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={model.Descr} />
                                                        </div>

                                                        {/*ULTIMA ACTUALIZACIÓN*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="lblDescr">Última actualización</span>
                                                            </div>
                                                            <input
                                                                id="txtDescr"
                                                                title="Descripción"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={model.RtrictDate} />
                                                        </div>

                                                        {/*MOTIVO*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Motivo</span>
                                                            </div>
                                                            <textarea
                                                                type="text"
                                                                className="form-control styleTextarea"
                                                                id="txtComments"
                                                                placeholder="250 caracteres máximo"
                                                                maxLength={254}
                                                                disabled
                                                                value={model.RtrictResn} />
                                                        </div>
                                                    </div>

                                                    {/*SEGUNDA COLUMNA UBICACIONES*/}
                                                    <div className="col-12 col-md-6">
                                                        {/*CÓDIGO DE BARRAS*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="lblBarCode">Código de barras</span>
                                                            </div>
                                                            <input
                                                                id="txtBarCode"
                                                                title="Código de barras"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={model.BarCode} />
                                                        </div>
                                                        {/*CANTIDAD MINIMA*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="lblMinLevel">Cantidad mínima</span>
                                                            </div>
                                                            <input
                                                                id="txtMinLevel"
                                                                title="Cantidad mínima"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={model.MinLevel} />
                                                        </div>

                                                        {/*CANTIDAD MÁXIMA*/}
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="lblMaxLevel">Cantidad máxima</span>
                                                            </div>
                                                            <input
                                                                id="txtMaxLevel"
                                                                title="Cantidad máxima"
                                                                className="form-control"
                                                                type="text"
                                                                disabled
                                                                value={model.MaxLevel} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn botonCerrar text-white"
                                onClick={this.closeModal}>
                                Cerrar
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

export default connect(
    mapStateToProps
)(LocationModal);